import React from 'react';
import ChoiceButton from './ChoiceButton';

const greenColorScheme = {
  bgColor: '#F2F7F1',
  labelShadowColor: '#6BC94866',
  labelDropShadowColor: '#6BC94866',
  textColor: '#3C9D47',
  activeGradientStart: '#057036',
  activeGradientEnd: '#51BA62',
  activeBorderGradientStart: '#ABECB0',
  activeBorderGradientEnd: '#16570A',
  activeBoxShadowColor: '#BEDEC3',
  activeLabelInnerBg: '#0BBA55',
};

const GreenChoiceButton = (props) => {
  return <ChoiceButton {...props} colorScheme={greenColorScheme} />;
};

export default GreenChoiceButton;
